module.exports = __webpack_public_path__ + "static/oni-730ce78899455af75587572281e5045d.jpeg";